import { Office } from './office.model';

export class Official {
  public OfficialUniqueId: number = 0;
  public displayName: string = '';
  public givenNames: string = '';
  public id: number = 0;
  public office: Office = null;
  public politicianId: number = 0;
  public suffix: string = '';
  public surname: string = '';
  public title: string = '';
  public party: string = '';
  public photoUrl: string = '';
  public unAbbreviatedDisplayName: string = '';
}
